/*
 * @Author: 艾斯
 * @Date: 2019-11-21 17:14:16
 * @LastEditTime : 2020-01-04 09:56:14
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/router/index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/assess",
    name: "home",
    component: Home
  },
  {
    path: "/assess/list/sid/:sid/gid/:gid",
    name: "list",
    component: () => import("../views/assess/List.vue")
  },
  {
    path: "/assess/info/:id",
    name: "info",
    component: () => import("../views/assess/Info.vue")
  },
  {
    path: "/assess/analyse/sid/:sid/eid/:eid",
    name: "analyse",
    component: () => import("../views/assess/Analyse.vue")
  },
  {
    path: "/assess/result/eid/:eid/qid/:qid",
    name: "result",
    component: () => import("../views/assess/Result.vue")
  },
  {
    path: "/assess/share/sid/:sid/eid/:eid",
    name: "share",
    component: () => import("../views/assess/SharePage.vue")
  },
  {
    path: "/assess/report/sid/:sid/eid/:eid",
    name: "analyse",
    component: () => import("../views/assess/Report.vue")
  },
  {
    path: "/school/analyse/word",
    name: "schoolAnalyse",
    component: () => import("../views/analyseWord/Index.vue")
  },
  { path: "*", redirect: { name: "home" } } // 重定向到主页
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
